import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { logout } from "../../apis/auth";

const LogoutForm = () => {
  const { i18n, t } = useTranslation();

  const navigate = useNavigate();
  const [loadingAuthApi, setloadingAuthApi] = useState(false);

  const handleLogout = async (e) => {
    e.preventDefault();
    setloadingAuthApi(true);

    try {
      await logout();
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
      alert(t("errors.unexpectedError", { ns: "messages" }));
    } finally {
      setloadingAuthApi(false);
    }
  };

  return (
    <Button
      type="text"
      className="border-0 p-0"
      loading={loadingAuthApi}
      style={{
        boxShadow: "none",
        transform: "scale(1)",
      }}
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleLogout}
    >
      {i18n.dir() === "rtl" ? "تسجيل الخروج" : "Logout"}
    </Button>
  );
};

export default LogoutForm;
